/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, Popconfirm, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

import SystemUserAvatar from '../../../components/Custom/SystemUserAvatar'
import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedUser: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedUser
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">System Users</li>
								</ol>
							</div>
							<h4 className="page-title">System Users</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row type='flex' justify='center'>
									<Col md={24} sm={24}>
										<Row>
											<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
												this.setState({ isAddFormShown: true, isEdit: false, selectedUser: null })
											}} style={{ float: 'right' }}>Add New User</button>
											<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
												this.setState({ searchText: e.target.value })
											}}/>
										</Row>
										<br />
										<Row>
											<Query query={SYSTEM_USERS} variables={{ searchFilter: filters, barangay_uid }}>
												{({ loading, error, data }) => {
													if (error) return <Empty/>

													let systemUsers = _.has(data,'systemUsers') ? data.systemUsers.data : []
													systemUsers = systemUsers.map((systemUser, key) => Object.assign({}, systemUser, { key }))
													let _pagination = _.has(data, 'systemUsers') ? data.systemUsers.pagination : {}
													_pagination = Object.assign({}, _pagination, {
														pageSizeOptions: ['10', '25', '50'],
														showSizeChanger: true,
														total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
														showTotal: (total) => `Total ${total} items`
													})

													const columns = [{
														title: '#',
														key: 'user_avatar',
														width: 100,
														render: (record) => {
															return <SystemUserAvatar size={50} user_uid={record.uid}/>
														}
													}, {
														title: 'ID',
														dataIndex: 'uid',
														key: 'uid',
														//width: 300
													}, {
														title: 'Name',
														dataIndex: 'full_name',
														key: 'full_name'
													}, {
														title: 'Username',
														dataIndex: 'username',
														key: 'username'
													}, {
														title: 'Email',
														dataIndex: 'email',
														key: 'email'
													}, {
														title: 'Gender',
														dataIndex: 'gender',
														key: 'gender'
													}, {
														title: 'Temp. Password',
														dataIndex: 'temporary_password',
														key: 'temporary_password'
													}, {
														title: 'User Type',
														dataIndex: 'user_type',
														key: 'user_type'
													}, {
														title: 'Account Status',
														key: 'account_status',
														render: (record) => {
															const mStatus = _.isEqual(record.is_activated, 1) ? 'Activated' : 'Deactivated'
															return <span>{mStatus}</span>
														}
													}, {
														title: 'Action',
														key: 'action',
														width: 300,
														render: (record) => {
															return (
																<React.Fragment>
																	<a 
																		style={{ marginRight: 10 }}
																		href="javascript:void(0)" 
																		onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedUser: record })}
																	>Edit</a>
																	<Popconfirm
																		title="Do you want to delete this user?"
																		onConfirm={() => {
																			const { deleteUser } = this.props
																			deleteUser(record.uid)
																		}}
																		okText="Yes"
																		cancelText="No"
																	>
																		<a style={{ marginRight: 10 }} href='javascript:void(0)'>Delete</a>
																	</Popconfirm>
																	{
																		!record.temporary_password &&
																		<Popconfirm
																			title="Do you want to reset password for this user?"
																			onConfirm={() => {
																				const { resetPassword } = this.props
																				resetPassword(record.uid)
																			}}
																			okText="Yes"
																			cancelText="No"
																		>
																			<a href='javascript:void(0)'>Reset Password</a>
																		</Popconfirm>
																	}
																</React.Fragment>
															)
														}
													}]
													return (
														<Table 
															loading={loading}
															columns={columns} 
															dataSource={systemUsers} 
															bordered
															onChange={this.handleOnChange}
															pagination={_pagination}
															scroll={{ x: 1020 }}
														/>
													)
												}}
											</Query>
										</Row>
										{
											isAddFormShown &&
											<AddForm
												isEdit={isEdit}
												selectedUser={selectedUser}
												visible={isAddFormShown}
												onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedUser: null })}
											/>
										}
									</Col>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const SYSTEM_USERS = gql`
    query systemUsers($barangay_uid: String, $searchFilter: SearchParams) {
		systemUsers(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const RESET_PASSWORD = gql`
    mutation resetUserPassword($user_uid: String) {
		resetUserPassword(user_uid: $user_uid)
    }
`

const DELETE_USER = gql`
    mutation deleteUserAccount($user_uid: String) {
		deleteUserAccount(user_uid: $user_uid)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(RESET_PASSWORD, {
		props({ mutate }) {
			return {
				resetPassword(user_uid) {
					return mutate({
						variables: { user_uid },
					  	refetchQueries: ['systemUsers']
					})
				}
			}
		}
	}),
	graphql(DELETE_USER, {
		props({ mutate }) {
			return {
				deleteUser(user_uid) {
					return mutate({
						variables: { user_uid },
					  	refetchQueries: ['systemUsers']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
